import React, { useState, useEffect } from 'react';
import { IWebSiteDetails, webSiteService } from '../webSite/webSiteService';
import { Tooltip } from 'antd';

export function QuickNav() {
	//列表数据源
	const [dataSource, setDataSource] = useState<IWebSiteDetails[]>([]);

	//列表查询
	const loadData = async () => {
		const searchParams = {
			pageSize: -1,
			pageNum: 1,
		}
		let { retData } = await webSiteService.page(searchParams);
		const { records, ...pg } = retData;
		setDataSource(records);
	}

	useEffect(() => {
		loadData();
	}, []);

	//跳转
	const open = (url?: string) => {
		window.open(url, '_blank');
	}

	return (
		<div className="home-content-right-quickNav">
			<div className="home-but-wrapper">
				<span onClick={() => open()}>网站快速导航</span>
			</div>
			<ul className="quickNav-warpper">
				{dataSource && dataSource.map(item => (
					<Tooltip title={item.name} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"} key={item.id}>
						<li className="quickNav-item" key={item.id}><span onClick={() => open(item.code)}>{item.name}</span></li>
					</Tooltip>
				))}
			</ul>
		</div>
	);
}

